module.exports = "dist/images/components-design-separator-control-curve-2.7a9883c.png";